// istanbul ignore file

import { Stage, stageFromString } from '@eventbrite/webapp-constants';

const getStageEnv = () => {
    if (process.env.STAGE) {
        return process.env.STAGE;
    }
    if (process.env.NODE_ENV === 'development') {
        console.warn('No STAGE environment variable found, using TEST');
    }
    return Stage.TEST;
};

export function getStage() {
    return stageFromString(getStageEnv());
}
